import axios from "axios";
import axiosInstance from "../../../../axiosInterceptor";

export const getAuditRows = async (pageNo = 1, filters) => {
  const {header_id,file_type}=filters;
  const parsedArray=header_id.map((id)=>+id);
  const parsedFileType=file_type.flat();
  
  // let payload = "";
  // console.log("PAYLOAD::::", filters);
  // Object.entries(filters).map((filter) => {
  //   if (!filter[1]) {
  //     return;
  //   }
  //   if (typeof filter[1] === "string") {
  //     payload += `&${filter[0]}=${filter[1]}`;
  //     return;
  //   }
  //   filter[1].map((option) => {
  //     payload += `&${filter[0]}=${option}`;
  //   });
  // });
  // console.log("FILTERS:::::", { filters, payload });
  // const v4EndPoint =
  //   "https://x8zya18gei.execute-api.ap-southeast-2.amazonaws.com/filter_api_v4/";
  const v5EndPoint =
    // "https://cc828zz982.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v2";
    "https://48o6s9uo53.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v3"
    return await axiosInstance
    .post(
      v5EndPoint,
      {
        ...filters,
        page_number: pageNo,
        header_id:parsedArray,
        file_type:parsedFileType
      },
    )
    .then((response) => {
      // const data = JSON.parse(response.data.body);
      const data = response.data;
      if (typeof data?.data === "string") {
        throw new Error(response.data.data);
      }
      const auditRows = data.data.audited_rows;
      return auditRows;
    })
    .catch((error) => {
      //console.log("Error in AuditRows Get request:", error);
      throw new Error(error.message);
    });
};

export const getauditData = async (hcp_line_id) => {
  try {
    const getapiEndpointv3 =
    "https://47lbkb5xl4.execute-api.ap-southeast-2.amazonaws.com/episode_details_ics_v2";
    const response=await axiosInstance.post(getapiEndpointv3,null,{
      params:{
        hcp_line_id:hcp_line_id,
      },
    });
    const auditData = response.data;
    return auditData; 
  } catch (error) {
    //console.log("Error in Auditdetail Get request:", error);
    throw new Error(error.message);
  }
  // return await axiosInstance
  //   .post(getapiEndpointv3, {
  //     params:{
  //       hcp_line_id:id,
  //     }
  //   })
  //   .then((response) => {
  //     const auditData = JSON.parse(response.data.body);
  //     return auditData.message;
  //   })
  //   .catch((error) => {
  //     console.log("Error in Auditdetail Get request:", error);
  //     throw new Error(error.message);
  //   });
};

export const episodeUnAssignedUsers = async (selectedEpisodeRows, assginedById, addUnassignReason, isAllEpisodesSelected, filtersObj, recall_page,header_id) => {
  console.log(selectedEpisodeRows, 'selectedEpisodeRows');
  console.log(assginedById, 'assginedById');
  console.log(addUnassignReason, 'addUnassignReason');
  console.log(isAllEpisodesSelected, 'isAllEpisodesSelected');
  console.log(filtersObj, 'filtersObj');
  console.log(recall_page, 'recall_page');
  console.log(header_id, 'header_id');
const unassginepayload = {
    hcp_lines: selectedEpisodeRows,
    unassigned_by: assginedById,
    unassignment_reason: addUnassignReason,
    select_all: isAllEpisodesSelected,
    user_id: assginedById,
    filter: {
      is_flagged: !recall_page ? !recall_page : false,
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
      status: filtersObj.status ? filtersObj.status : [],
      coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
      header_id: header_id ? header_id : [],
      admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
      admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
      separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
      separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
      file_type: filtersObj.fileType ? filtersObj.fileType : [],
      length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
      assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
      assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
      case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
      page_number: filtersObj.page_number ? filtersObj.page_number : 1,
    }
  }
// const url = "https://nusk7ch374.execute-api.ap-southeast-2.amazonaws.com/ics_dev/unassignFunctionalityICSV1";
const url = "https://pdkc5mkvzd.execute-api.ap-southeast-2.amazonaws.com/unassignFunctionalityICSV1/";
  try {
    const response=await axiosInstance.post(url, unassginepayload);
    console.log(response, "unassginepayload")
    const result = response.data;
    return result;
  } catch (error) {
    if(error.response.status === 401){
      return error;
    }else{
      throw new Error(error.message);
    }
  }
};

export const fetchUnassignedEpisodes = async(assginedById,  filtersObj, recall_page,header_id,page_number,unassined_page)=>{
  // const url = "https://nusk7ch374.execute-api.ap-southeast-2.amazonaws.com/ics_dev/unassignedEpisodesICSV1"
  const url =" https://ut4h5690nc.execute-api.ap-southeast-2.amazonaws.com/unassignedEpisodesICSV1/"
  const fetchPaload = {
    user_id:assginedById,
    filters:{
      is_flagged:true,
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
        status: filtersObj.status ? filtersObj.status : [],
        coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
        header_id: header_id ? header_id : [],
        admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
        admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
        separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
        separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
        file_type: filtersObj.fileType ? filtersObj.fileType : [],
        length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
        assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
        assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
        case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
        page_number: page_number ? page_number : 1,
        unassigned_by: []
    }
  }
  try {
    const response = await axiosInstance.post(url,fetchPaload)
  console.log(response,"fetching unassigned episodes")
  const result = response.data.data;
  console.log("result",response.data.data)
      return result;
  } catch (error) {
    if(error.response.status === 401){
      return error;
    }else{
      throw new Error(error.message);
    }
  }
  
  
}
export const getFilteredAuditData = async (filters,pageNumber=1) => {
  //console.log(filters);
  
  const {header_id,file_type}=filters;
  const parsedArray=header_id.map((id)=>+id);
  const parsedFileType=file_type.flat();
 // const parsedFile=file_type.flat().map(str=>parseInt())
  // const getapiEndpoint =
  //   "https://nw71l5ckl4.execute-api.ap-southeast-2.amazonaws.com/webwork_flow_filter_api/";
  // const v3EndPoint ="https://os3wl7iyn2.execute-api.ap-southeast-2.amazonaws.com/workflow_filter_api_v3/"
  // const v4EndPoint =
  //   "https://x8zya18gei.execute-api.ap-southeast-2.amazonaws.com/filter_api_v4/";
  const v5EndPoint =
    // "https://cc828zz982.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v2";
    "https://48o6s9uo53.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v3"
  return await axiosInstance
    .post(v5EndPoint, {
      page_number:pageNumber,
        ...filters,
        header_id:parsedArray,
        file_type:parsedFileType
    })
    .then((response) => {
      if (response.data.errorMessage) {
        throw new Error(response.data.errorMessage);
      }
      const filteredAuditData = response.data.data.audited_rows;
      // console.log('filteredAuditData',filteredAuditData)
      return filteredAuditData;
    })
    .catch((error) => {
      //console.log("Error in FilteredAuditdetail  request:", error);
      throw new Error(error.message);
    });
};

export const getSearchData = async (searchData,filters,flagStatus) => {
  const {header_id,file_type}=filters;

  const parsedArray=header_id.map((id)=>+id);
  const parsedFileType=file_type.flat();
  const url =
    "https://48o6s9uo53.execute-api.ap-southeast-2.amazonaws.com/hcp_data_filter_api_ics_v3";
  const params = {
    // episode_identifier: "I516064"
    episode_identifier: searchData,
    is_flagged:flagStatus
  };
  return axiosInstance
    .post(url, { page_number:1,
        ...filters,
        episode_identifier:[searchData],
        header_id:parsedArray,
        file_type:parsedFileType })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const lastAuditdata = async(hcp_line_updated_at,page_number) =>{
  const url =
    `https://wxvs0cgtj7.execute-api.ap-southeast-2.amazonaws.com/get_last_updated_at_or_recommendations_ics_v1`;
    const params = {
      page_number:page_number,
      hcp_line_updated_at:hcp_line_updated_at
    }
  try {
    const response = await axiosInstance.get(url,{params});
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
}


export const uploadeByuser = async(uploaded_by_user_name,page_number) =>{
  const url =
    `https://x3wxr25hfe.execute-api.ap-southeast-2.amazonaws.com/get_uploaded_by_user_names_or_recommendations_ics_v1`;
    const params = {
      page_number:page_number,
      uploaded_by_user_name:uploaded_by_user_name
    }
  try {
    const response = await axiosInstance.get(url,{params});
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const codedBynameUser = async(coder_name,page_number) =>{
  const url =`https://86bhjlmwqk.execute-api.ap-southeast-2.amazonaws.com/get_coded_by_user_names_or_recommendations_ics_v2`
  const params = {
    page_number:page_number,
    coder_name:coder_name
  }
  try{
    const response = await axiosInstance.get(url,{params})
    return response.data
  }catch(error){
  throw new error
  }
}

export const getSearchRecommendations = async (filters,identifier,flagStatus) => {

  
  const url =
     "https://55q16h43a2.execute-api.ap-southeast-2.amazonaws.com/search_by_episode_identifier_recommendation_ics_v3"
  
  try {
    const response = await axiosInstance.post(url, {
     ...filters,episode_identifier:[identifier.toUpperCase()],
     page_number:1
    });
    
    if(response.message){
      //console.log('messge',response.message,response);
      
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};


export const getUsers = async (userName, pageNumber) => {
  const url =
    "https://4j37pvqbw7.execute-api.ap-southeast-2.amazonaws.com/get_user_names_or_recommendations_ics_v1";
    let queryParams = {};
    if (userName && userName.length > 0) {
      queryParams.user_name = userName;
      queryParams.page_number = pageNumber;
    } else {
      queryParams.page_number = pageNumber;
    }
  try {
    const response = await axiosInstance.get(url, {
      params: queryParams,
    });
    if(response.message){
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getShortDescriptions = async (shortDescription, pageNumber) => {
  const url =
    "https://7b7ucv39ie.execute-api.ap-southeast-2.amazonaws.com/get_short_description_or_recommendations_ics_v1";
    let queryParams = {};
    if (shortDescription && shortDescription.length > 0) {
      queryParams.short_description = shortDescription;
      queryParams.page_number = pageNumber;
    } else {
      queryParams.page_number = pageNumber;
    }
  try {
    const response = await axiosInstance.get(url, {
      params: queryParams,
    });
    if(response.message){
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getDrg = async (drg ,pageNumber)=>{
  const url = "https://b0bh8xtmlh.execute-api.ap-southeast-2.amazonaws.com/getDrgCodesOrRecommendationsIcsV1"
  let queryParams = {};
  if(drg && drg.length > 0){
    queryParams.drg_code = drg
    queryParams.page_number = pageNumber
}
else{
  queryParams.page_number = pageNumber
}
try {
  const response = await axiosInstance.get(url,{params:queryParams})
  if(response.message){
    return response.message
  }
  return response.data
  
} catch (error) {
  throw new Error(error.message);
}
}

export const getReferenceIds = async (referenceID, pageNumber) => {
  const url =
    "https://halj7sweq4.execute-api.ap-southeast-2.amazonaws.com/get_reference_id_or_recommendations_ics_v1";
    let queryParams = {};
    if (referenceID && referenceID.length > 0) {
      queryParams.audit_ref_no = referenceID;
      queryParams.page_number = pageNumber;
    } else {
      queryParams.page_number = pageNumber;
    }
  try {
    const response = await axiosInstance.get(url, {
      params: queryParams,
    });
  
    if(response.message){
      return response.message;
    }
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const episodeAssignedUsers = async (selectedEpisodeRows, selectedAssgineeUser, assginedById, addAssigeReason, isAllEpisodesSelected, filtersObj, recall_page,header_id,unassined_page) => {
  const assginePayload = {
    hcp_lines: selectedEpisodeRows ? selectedEpisodeRows : [],
    assigned_user_id: selectedAssgineeUser ? selectedAssgineeUser : null,
    assigned_by: assginedById ? assginedById : null,
    assignment_reason: addAssigeReason ? addAssigeReason : "",
    select_all: isAllEpisodesSelected,
    assignment:!unassined_page,
    filter: {
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
      status: filtersObj.status ? filtersObj.status : [],
      file_type: filtersObj.fileType ? filtersObj.fileType : [],
      header_id: header_id ? header_id : [],
      coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
      admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
      admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
      separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
      separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
      length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
      assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
      assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
      case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
      page_number: filtersObj.page_number ? filtersObj.page_number : 1,
      is_flagged: recall_page ? recall_page : false
    }
  }
  try {
    const userAssignments =
    "https://j00d0t33vk.execute-api.ap-southeast-2.amazonaws.com/episode_assignment_v1";
    const response=await axiosInstance.post(userAssignments,assginePayload);
    const episodeData = response.data;
    return episodeData;
  } catch (error) {
    if(error.response.status === 401){
      return error;
    }else{
      throw new Error(error.message);
    }
  }
};


export const auditStatusUpdate = async (auditDetails,flagauditRows) => {
  //console.log('Checkall',auditDetails,flagauditRows)
  const {
    findings,
    comments,
    admission_date,
    seperation_date,
    sameday_status,
    episode_identifier,
    file_name,
    insurer_identifier,
    medical_record_number,
    name,
    current_drg_revenue,
    audit_status, // Destructure and omit findings
    ...otherAuditDetails // Collect all other properties
  } = auditDetails;
  const payload = {
    ...otherAuditDetails, // Spread other audit details excluding findings
    is_flagged: flagauditRows?true:false,
    status:auditDetails.audit_status // Set specific flag status
  };
  // const urlv3 =
  //   "https://svga801o97.execute-api.ap-southeast-2.amazonaws.com/work_flow_edit_audit_row_v3/";
  const urlv4 =
    "https://szshr83nhj.execute-api.ap-southeast-2.amazonaws.com/episode_edit_ics_v1/";
  const response = await axiosInstance.put(urlv4,payload);
  if (response.data.errorMessage) {
    throw new Error(response.data.errorMessage);
  }
  const message = response.data.hcp_line_id;
  return message;
};
export const getAuditFiles = async (pageNumber = 1) => {
  const url =
    "https://f9lqbrokx9.execute-api.ap-southeast-2.amazonaws.com/get_header_file_ics_v1";
  try {
    const response = await axiosInstance.get(url,{
      params: {
        page_number: pageNumber,
      },
    });
    return response.data.data.headers;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPassedRecords = async (pageNo) => {
  const url = `https://8yrsa3a6tf.execute-api.ap-southeast-2.amazonaws.com/get_passed_records_v1/?pageNumber=${pageNo}`;
  try {
    const response = await axios.get(url);
    if (typeof response.data?.message === "string") {
      throw new Error(response.data.message);
    }
    return response.data.message.audited_rows;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPassedRecordsDetails = async (id) => {
  const url = `https://k5glluopp7.execute-api.ap-southeast-2.amazonaws.com/get_passed_records_detailed_v1/?id=${id}`;
  try {
    const response = await axios.get(url);
    return response.data.meesage;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getfilteroptionsdata = async () => {
  const url =
    // "https://ay1ftqti40.execute-api.ap-southeast-2.amazonaws.com/filter_hcp_data_ics_v1/";
    "https://rsva7s1dth.execute-api.ap-southeast-2.amazonaws.com/get_filter_options_ics_v2"
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const recall_episode = async (episodes) => {
  //console.log('zsdf',episodes)
  if(!localStorage.breadcrumbClick){
  const payload = {
    page_number: episodes.page_number,
  };
  const endPointUrl =
    "https://xiqtsjlpr5.execute-api.ap-southeast-2.amazonaws.com/flagged_episodes_ics_v2";
    try {
      const response = await axiosInstance.post(endPointUrl, payload);
      return response;  
    } catch (error) {
      return error.message
    }
  }
};
export const flag_and_unflag = async (selectedEpisodeRows, selectedAssgineeUser, assginedById, addAssigeReason, isAllEpisodesSelected, filtersObj, recall_page,header_id) => {
  console.log(recall_page);
  console.log(header_id,'filobj');
  
  const payload = {
    hcp_lines: selectedEpisodeRows ? selectedEpisodeRows : [],
    select_all: isAllEpisodesSelected,
    filter: {
      insurer_identifier: filtersObj.insurerIdentifier ? filtersObj.insurerIdentifier : [] ,
      priority_value: filtersObj.priorityValue ? filtersObj.priorityValue : [],
      status: filtersObj.status ? filtersObj.status : [],
      file_type: filtersObj.fileType ? filtersObj.fileType : [],
      header_id: header_id ? header_id : [],
      coder_name: filtersObj.codedBy ? filtersObj.codedBy : [],
      admission_date_from: filtersObj.fromAdmissionDate ? filtersObj.fromAdmissionDate : "",
      admission_date_to: filtersObj.toAdmissionDate ? filtersObj.toAdmissionDate : "",
      separation_date_from: filtersObj.fromSeparationDate ? filtersObj.fromSeparationDate : "",
      separation_date_to: filtersObj.toSeparationDate ? filtersObj.toSeparationDate : "",
      length_of_stay: filtersObj.length_of_stay ? filtersObj.length_of_stay : [],
      assigned_by: filtersObj.assigned_by ? filtersObj.assigned_by : [],
      assigned_to: filtersObj.assigned_to ? filtersObj.assigned_to : [],
      case_mix_speciality: filtersObj.case_mix_speciality ? filtersObj.case_mix_speciality : [],
      page_number: filtersObj.page_number ? filtersObj.page_number : 1,
      is_flagged: !recall_page ? !recall_page : false
    },
    flag_episode_to:recall_page ? recall_page : false
  }
  const endPointUrl =
    "https://dfd2glj3ii.execute-api.ap-southeast-2.amazonaws.com/flag_unflag_episodes_ics_v1";
    try {
      const response = await axiosInstance.post(endPointUrl, payload);
      console.log(response,'ppp',);
      return response;  
    } catch (error) {
      return error.message
    }
};

export const getworkFlowDashBaord = async(pageNumber) =>{
  console.log("hello")
  const url = "https://n7s1pvytm0.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_fetch_files_ics_v1"
  try{
    const response = await axiosInstance.get(url,{ params: {
      page_number: pageNumber,
    },}
     
    )
    console.log(response,"files");
    return response.data
  } catch(errorr){
    throw new Error(errorr.message)
  }
}


export const getFiltersOptionsData = async(dropdonwName,pageNumber)=>{
  const url = "https://ej5y5kwwx4.execute-api.ap-southeast-2.amazonaws.com/get_filter_workflow_dashboard_v1";
  try {
    const response = await axiosInstance.get(url,{ params: {
      page_number: pageNumber,
      key:dropdonwName
    },});
    console.log(response);
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getDoughnutData = async (filterOptions)=>{
  
  const url ="https://krnzuqloj8.execute-api.ap-southeast-2.amazonaws.com/get_filters_pie_chart_v1";

  // const url ="https://9yoromuzh2.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_doughnutchart_data";
  try {
    const response = await axiosInstance.post(url,
  {
      header_id:[...filterOptions?.headerId],
      insurer_identifier:[...filterOptions.insurerIdentifier],
      case_mix_speciality:[...filterOptions.caseMixSpeciality],
      length_of_stay:[...filterOptions.lengthOfStay],
      coder_name:[...filterOptions.codedBy],
      priority_value:[...filterOptions.priorityValue],
    
     selectallfiles:filterOptions.selectAllHeaderId,
     selectallspeciality:filterOptions.selectAllCaseMixSpecality,
     selectallcoder:filterOptions.selectAllCodedBy,
     selectallpriority:filterOptions.selectAllPriority,
     selectallinsurer:filterOptions.selectAllInsurerIdentifier

   }
  )
    // console.log(response)
    console.log(response.data)
  
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}


export const getDrgErrorData = async (filterOptions)=>{
  const url ="https://vqfkwn7wah.execute-api.ap-southeast-2.amazonaws.com/drg_error_rate_calculation_v1";

  // const url ="https://6rr63q74wk.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_drg_errordata";
  try {
    const response = await axiosInstance.post(url,{
       header_id:[...filterOptions?.headerId],
       insurer_identifier:[...filterOptions.insurerIdentifier],
       case_mix_speciality:[...filterOptions.caseMixSpeciality],
       length_of_stay:[...filterOptions.lengthOfStay],
       coder_name:[...filterOptions.codedBy],
       priority_value:[...filterOptions.priorityValue],
       selectallfiles:filterOptions.selectAllHeaderId,
     selectallspeciality:filterOptions.selectAllCaseMixSpecality,
     selectallcoder:filterOptions.selectAllCodedBy,
     selectallpriority:filterOptions.selectAllPriority,
     selectallinsurer:filterOptions.selectAllInsurerIdentifier
    })
    console.log(response.data)
    console.log(response)
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getDrgOptimizationData = async (filterOptions)=>{
  const url = "https://yyhj8v46j9.execute-api.ap-southeast-2.amazonaws.com/drg_optimisation_v1";

  // const url = "https://yp23242wy5.execute-api.ap-southeast-2.amazonaws.com/workflow_dashboard_drg_optimization";
  try {
    const response = await axiosInstance.post(url,{
      header_id:[...filterOptions?.headerId],
       insurer_identifier:[...filterOptions.insurerIdentifier],
       case_mix_speciality:[...filterOptions.caseMixSpeciality],
       length_of_stay:[...filterOptions.lengthOfStay],
       coder_name:[...filterOptions.codedBy],
       priority_value:[...filterOptions.priorityValue],
       selectallfiles:filterOptions.selectAllHeaderId,
       selectallspeciality:filterOptions.selectAllCaseMixSpecality,
       selectallcoder:filterOptions.selectAllCodedBy,
       selectallpriority:filterOptions.selectAllPriority,
       selectallinsurer:filterOptions.selectAllInsurerIdentifier
    })
  
    console.log(response.data)
    // console.log(res)
    // console.log(response.data.data)
    return response.data;
  } catch (error) {
    throw new Error(error.message)
  }
}

